/* eslint-disable @typescript-eslint/no-floating-promises */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files directly
import enTranslation from '@/locales/en/translation.json'
import enErrors from '@/locales/en/errors.json'
import esTranslation from '@/locales/es/translation.json'
import esErrors from '@/locales/es/errors.json'

const resources = {
  en: {
    translation: enTranslation,
    errors: enErrors
  },
  es: {
    translation: esTranslation,
    errors: esErrors
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    supportedLngs: ['en', 'es'],
    nonExplicitSupportedLngs: true
  })

export default i18n
